import { render, staticRenderFns } from "./SearchResultsRecordPWA.vue?vue&type=template&id=0e1edda6"
import script from "./SearchResultsRecordPWA.vue?vue&type=script&lang=js"
export * from "./SearchResultsRecordPWA.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsRecordPWA.vue?vue&type=style&index=0&id=0e1edda6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports